<template>
  <form
    ref="form"
    class="relative"
    @submit.prevent="
      (e) => {
        searchEvent()
      }
    "
  >
    <label for="search" class="mb-2 text-sm font-medium text-gray-900 sr-only "
      >Поиск</label
    >
    <div class="relative">
      <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
        <MagnifyingGlassIcon class="w-4 h-4 text-gray-500 ">

        </MagnifyingGlassIcon>
      </div>
      <input
        ref="searchInput"
        type="search"
        id="search"
        class="block w-full p-[0.38rem] ps-10 text-base text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 "
        placeholder="Поиск"
        required
        v-model="searchValue"
        autocomplete="off"
      />
      <button
        v-if="props.props.showSearchButton"
        @click.prevent="searchEvent"
        class="text-white absolute end-2.5 bottom-[0.2rem] bg-red-700 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-[0.35rem] "
      >
        Поиск
      </button>
    </div>
    <div
      @click="
        () => {
          if (!searchInput) {
            return
          }
          searchInput.focus()
        }
      "
      v-show="showPopup"
      class="flex bg-white w-full shadow-2xl z-10 rounded-md pb-4 justify-between"
      :key="height"
      :style="{ position: 'absolute', left: 0, top: height }"
    >
      <ul class="ml-[1.75rem] flex gap-2 items-center justify-center py-2 rounded-sm">
        <template :key="symbol" v-for="symbol in symbols">
          <li
            @click="
              () => {
                searchValue += symbol
              }
            "
            tabindex="0"
            class="p-2 bg-red-700 text-white hover:bg-red-800 cursor-pointer rounded-xl w-8 h-w-8 justify-center items-center flex"
          >
            {{ symbol }}
          </li>
        </template>
      </ul>

      <div class="flex items-center pr-4">
        <XMarkIcon tabindex="0" class="h-6 w-6 text-black cursor-pointer hover:text-red-900" @click="emit('restart')"></XMarkIcon>
      </div>
    </div>
  </form>
</template>
<script lang="ts" setup>
import { onMounted, ref, watch } from 'vue'
import { useElementSize, useFocus, computedAsync, onKeyStroke } from '@vueuse/core'
import { XMarkIcon,MagnifyingGlassIcon } from '@heroicons/vue/24/solid';
import queryString from 'query-string'

const props = defineProps<{
  props: {
    url: string
    enterEvent?: boolean
    showSearchButton?: boolean
  }
}>()


const emit = defineEmits<{
  (e: 'value', value: string): void
  (e: 'enter'): void
  (e: 'restart') :void
}>()

const searchInput = ref<null | HTMLInputElement>(null)
const form = ref<null | HTMLFormElement>(null)

const { height } = useElementSize(searchInput)
const { focused } = useFocus(searchInput)

onKeyStroke(['Escape'], () => {
  if (!searchInput.value || !focused.value) {
    return
  }
  searchInput.value.blur()
})

const searchValue = ref<string>('')
watch(searchValue, (v) => {
  emit('value', v)
})
onMounted(() => {
  const searchParsed = queryString.parse(window.location.search)
  searchValue.value = searchParsed.search?.toString() ?? ''
  emit('value', searchValue.value)
})
const symbols = ['ҥ', 'ҕ', 'ө', 'һ', 'ү', 'үө']

const searchEvent = () => {
  if (props.props.enterEvent) {
    emit('enter')
    return
  }
  const v = searchValue.value.trim()
  if (v == '') {
    return
  }
  const r = queryString.parseUrl(props.props.url)

  r.query.search = searchValue.value

  window.location.href = queryString.stringifyUrl({ url: r.url, query: r.query })
}

const showPopup = computedAsync(async () => {
  if (focused.value) {
    return true
  }
  await new Promise((resolve) => setTimeout(resolve, 200))
  return false
}, false)
</script>
